var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInviteGroupChatBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "24px",
    viewBox: "0 0 27 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icInviteGroupChatBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---three-dots-popup",
    transform: "translate(-24.000000, -693.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(9.000000, 407.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(12.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icInviteGroupChatBlack",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0359369,16.9605737 C26.5131728,13.4849031 26.1344976,8.72304854 22.7509047,5.62119639 C21.2049104,4.20398076 19.2340269,3.32170708 17.105024,3.07531535 C17.0917556,3.05899271 17.0781868,3.04282028 17.0633162,3.02734882 C15.2111974,1.10343042 12.5503068,0 9.76294083,0 C4.45863396,0 0,3.95213146 0,9.0125 C0,10.7867108 0.551114375,12.4875197 1.59801639,13.956407 L0.135537986,18.5480755 C0.0436104861,18.8366758 0.134035903,19.1521633 0.364805972,19.3482853 C0.595976597,19.5447578 0.922078889,19.5825102 1.19150257,19.4454701 L5.63902111,17.1839835 C6.55238792,17.577279 7.52093125,17.8353369 8.52392236,17.9527498 C10.4587058,19.9873717 13.1339663,21.0291667 15.8710125,21.0291667 C17.2937858,21.0291667 18.711402,20.7392145 19.9947319,20.1881001 L24.4424508,22.4496869 C24.5501501,22.5044628 24.6667619,22.53125 24.7826726,22.53125 C25.2895256,22.53125 25.6528796,22.0373149 25.4984153,21.5522422 L24.0359369,16.9605737 Z M5.94214153,15.6727876 C5.73179979,15.572899 5.48711042,15.5762036 5.27957257,15.68175 L2.11182903,17.292484 L3.14626375,14.0446794 C3.22156819,13.8082015 3.17525396,13.5498431 3.02244201,13.3543219 C2.02776243,12.081056 1.50198319,10.5797237 1.50198319,9.0125 C1.50198319,4.87125625 5.20782306,1.50208333 9.76294083,1.50208333 C11.597285,1.50208333 13.3631842,2.0578041 14.795621,3.05854208 C9.97153014,3.54361486 6.10807167,7.31154083 6.10807167,12.0166667 C6.10807167,13.4800964 6.48319194,14.8889504 7.19042285,16.1512011 C6.76222896,16.0236742 6.34520056,15.8642031 5.94214153,15.6727876 L5.94214153,15.6727876 Z M20.3543808,18.6858666 C20.1498471,18.5818724 19.9049574,18.5756137 19.6918118,18.6769542 C18.5209378,19.2331256 17.1997554,19.5270833 15.8710125,19.5270833 C11.3158947,19.5270833 7.61005486,16.1579104 7.61005486,12.0166667 C7.61005486,7.87542292 11.3158947,4.50625 15.8710125,4.50625 C20.4261303,4.50625 24.1319701,7.87542292 24.1319701,12.0166667 C24.1319701,13.5838903 23.6061909,15.0852226 22.6114612,16.3584385 C22.4586994,16.5539597 22.4123851,16.8123181 22.4876395,17.048796 L23.5220742,20.2966006 L20.3543808,18.6858666 Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.8169767,
    cy: 12.0166667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.8209931,
    cy: 12.0166667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.8249595,
    cy: 12.0166667,
    r: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInviteGroupChatBlack);
export default __webpack_public_path__ + "static/media/icInviteGroupChatBlack.9ab652b6d7e36adeb76eedf1729ddccf.svg";
export { ForwardRef as ReactComponent };